import React, { useEffect } from 'react';
import { ProductIntro } from './ProductIntro';
import { TomosList } from './TomosList';
import { Bonos } from './Bonos';
import { Urgency } from './Urgency';
import { Pricing } from './Pricing';
import { EliteValue } from './EliteValue';
import { Comparison } from './Comparison';
import { Testimonials } from './Testimonials';
import { Guarantee } from './Guarantee';
import { Faq } from './Faq';
import { FinalClose } from './FinalClose';
import { Footer } from './Footer';
interface DeferredContentProps {
  onCta: () => void;
  onReady: () => void;
}

/** Long-form sales content stays outside the critical rendering path. */
export function DeferredContent({
  onCta,
  onReady
}: DeferredContentProps) {
  useEffect(() => {
    onReady();
  }, [onReady]);
  return <>
      <ProductIntro data-id="element-55" data-mp="3fodhnh47f86u" />
      <TomosList data-id="element-56" data-mp="3fnu92r0g1w5h" />
      <Bonos data-id="element-57" data-mp="3fnapz6z251pv" />
      <Urgency data-id="element-58" data-mp="3fmspfy5d41c5" />
      <div id="pricing" className="scroll-mt-4" data-id="element-59" data-mp="3kflr2d5jatk0">
        <Pricing data-id="element-60" data-mp="3kgdnfq6ygvbc" />
      </div>
      <EliteValue data-id="element-61" data-mp="3khotjwnvif5m" />
      <Comparison data-id="element-62" data-mp="2dd9ejsk17alx" />
      <Testimonials data-id="element-63" data-mp="2dcq5z2g9tykk" />
      <Guarantee data-id="element-64" data-mp="2de18z01w72am" />
      <Faq data-id="element-65" data-mp="2ddhpvg0ia7v0" />
      <FinalClose onCta={onCta} data-id="element-66" data-mp="2db5c7f1s6jnr" />
      <Footer data-id="element-67" data-mp="28ees8gmuv3x2" />
    </>;
}